import React, {useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import {useSelector} from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import ReportMasterMediaSearchTable from './ReportMasterMediaSearchTable';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';

const ReportMasterMediaSearch = ({
  setValue,
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  handleClose,
  setBreCode,
  setRuleCode,
  handleDialog,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const initialValues = {
    description: '',
    code: '',
  };

  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
  };
  const [searchFlag, setSearchFlag] = useState(false);
  const {isLoading} = useSelector(({globalField}) => globalField);

  return (
    <div className={classes.ruleGroup}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleSubmit, handleReset, handleBlur} = props;
          return (
            <div className="mb-4">
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <ErrorBoundaryForComponents>
                    <Grid container>
                      <>
                        <Grid xs={4} className="px-1 form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Rule Group Code`}
                            label="Rule Group Code"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="code"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid xs={4} className="px-1 form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Rule Group Description`}
                            label="Rule Group Description"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                      </>
                    </Grid>
                  </ErrorBoundaryForComponents>
                </div>
                <div className="row justify-content-center">
                  <Button variant="contained" className={`mx-1 ${classes.buttonRoot}`}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                  >
                    Search
                  </Button>
                </div>
              </form>
              {isLoading && <PageLoader />}
            </div>
          );
        }}
      </Formik>
      <ReportMasterMediaSearchTable
        setValue={setValue}
        setBreCode={setBreCode}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        handleClose={handleClose}
        searchFlag={searchFlag}
        setRuleCode={setRuleCode}
        handleDialog={handleDialog}
      />
    </div>
  );
};

export default ReportMasterMediaSearch;
